import { forwardRef } from 'react';
// @mui
import Link from '@mui/material/Link';
import Box, { BoxProps } from '@mui/material/Box';
// routes
import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  customLogoUrl?: string;
  disabledLink?: boolean;
  iconOnly?: boolean;
  dark?: boolean;
  black?: boolean;
  large?: boolean;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ customLogoUrl = "", disabledLink = false, dark = false, black = false, iconOnly = false, large = false, sx, ...other }, ref) => {
    let svgUrl = "/logo/logo_single.svg";

    if (black) {
      svgUrl = iconOnly ? "/logo/logo_single_black_icon.svg" : "/logo/logo_single_black.svg"
    } else if (dark) {
      svgUrl = "/logo/logo_single_dark.svg";
    }
    const logo = (
      <Box
        ref={ref}
        component="div"
        sx={{
          height: "55px",
          maxHeight: "55px",
          display: 'inline-flex',
          ...sx,
        }}
        {...other}
      >

        <Box
          component="img"
          src={customLogoUrl || svgUrl}
          sx={{maxHeight: large ? "55px" : "35px", height: large ? "55px" : "35px"}}
        />

        {/* <Box component="div" sx={{ marginTop: 0, marginBottom: 0, fontSize: 26, fontWeight: "500" }}>
          {Constants.PRODUCT_NAME}
        </Box> */}
      </Box>
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link component={RouterLink} href="/" sx={{ display: 'contents' }}>
        {logo}
      </Link>
    );
  }
);

export default Logo;
